import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { ContentRoute, useSubheader } from "../../../_themeBase/layout";
import AccountInformation from "./AccountInformation";
// import { ProfileOverview } from "./ProfileOverview";
import ProfileChangePassword from "./ProfileChangePassword";
import PersonaInformation from "./PersonaInformation";
import EmailSettings from "./EmailSettings";
import { ProfileCard } from "./components/ProfileCard";
import ChangeMobile from "./ChangeMobile";
import ObjectPayment from "../../../_themeBase/layout/components/basePage/pages/object-payment/ObjectPayment";
import PaymentResultPage from "../Sport/EPay/PaymentResultPage";
import { lazy } from "react";
import ShowRankingTable from "./ShowRankingTable";
import ProfileOverview from "./ProfileOverview";

export default function UserProfilePage() {
  const suhbeader = useSubheader();
  //suhbeader.setTitle("User profile");

  const AddMeFormPage = lazy(() => import("../Auth/pages/saveMeForm/AddMeFormPage"));


  return (
    <div className="d-flex flex-row">
      {/* <div className="d-flex flex-row"> */}
      <ProfileCard></ProfileCard>
      <div className="flex-row-fluid ml-lg-8">
        <Switch>
          <Redirect
            from="/user-profile"
            exact={true}
            to="/user-profile/change-password"
          />
          <Route
            path="/user-profile/profile-overview"
            component={ProfileOverview}
          />
          <Route
            path="/user-profile/account-information"
            component={AccountInformation}
          />
          <Route
            path="/user-profile/change-password"
            component={ProfileChangePassword}
          />
          <Route
            path="/user-profile/change-mobile"
            component={ChangeMobile}
          />
          <Route
            path="/user-profile/email-settings"
            component={EmailSettings}
          />
          <Route
            path="/user-profile/personal-information"
            component={PersonaInformation}
          />

          <ContentRoute
            path="/user-profile/payment/:pid/result"
            render={(props) => (
              <PaymentResultPage
                {...props}
                basePath="/user-profile/payment"
              />
            )}
          />

          <ContentRoute
            path="/user-profile/payment"
            render={(props) => (
              <ObjectPayment
                {...props}
                isFullAccess={true}
                basePath="/user-profile/payment"
                api="api/User"
                reducerName="baseInfo"
                reduxState="users"
                subSystem="Dorm"
                transactionType={3}
                showTitle="MODULES.GENERAL.ADD.CREDIT"
              />
            )}
          />

          {/* <ContentRoute
            path="/user-profile/personal"
            render={(props) => (
              <AddMeFormPage
                {...props}
                basePath="/logout"
              />
            )}
          /> */}

          <Route
            path="/user-profile/personal"
            component={ProfileOverview}
          />

          <Route
            path="/user-profile/ranking"
            component={ShowRankingTable}
          />
          {/* <ContentRoute
            path="/user-profile/reqDormPreRegister"
            render={(props) => (
              <AddMeFormPage
                {...props}
                basePath="/logout"
              />
            )}
          /> */}

        </Switch>
      </div>
    </div>
  );
}
